import { useNotificationContext } from '@openeducation/oe-it-providers';

import { useOpenLink } from './use-open-link';
import { useRejoinClasses } from './use-rejoin-classes';
import { useUrlParams } from './use-url-params';

interface UseJoinClassProps {
  url: string;
  id?: string;
}
export const useJoinClass = ({ url = '' }: UseJoinClassProps) => {
  const { getParam } = useUrlParams(url?.replace('/classroom?', ''));
  const classroomUrl = getParam('classroomUrl');
  const classType = getParam('classType');
  const studentId = getParam('studentId');
  const classroomId = getParam('classroomId');
  const teacherId = getParam('teacherId');
  const learningMaterialUrl = getParam('learningMaterialUrl');
  const isPrivateClass = classType === 'PRIVATE_CLASS';

  const { openLink } = useOpenLink();
  const { reset: resetRejoinClasses } = useRejoinClasses();
  const { reset: resetNotifications } = useNotificationContext();

  const joinClass = () => {
    resetRejoinClasses();
    resetNotifications();
    if (classroomUrl) {
      openLink({
        link: classroomUrl,
      });
    }

    if (
      learningMaterialUrl &&
      learningMaterialUrl !== 'null' &&
      !isPrivateClass
    ) {
      openLink({
        link: learningMaterialUrl,
      });
    }

    if (isPrivateClass && studentId && classroomId) {
      if (!teacherId) {
        openLink({
          link: `/pending-feedbacks?studentId=${studentId}&classroomId=${classroomId}`,
          newTab: true,
        });
      } else {
        openLink({
          link: `/student-pending-feedback?studentId=${studentId}&classroomId=${classroomId}&teacherId=${teacherId}`,
          newTab: true,
        });
      }
    }
  };

  return { joinClass, joinClassUrl: url };
};
